/* eslint-disable @angular-eslint/directive-selector */
import { ElementRef, type AfterViewInit, inject } from '@angular/core';
import { Directive, Input } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[libAngularMyDatePickerCalendar]',
})
export class AngularMyDatePickerCalendarDirective implements AfterViewInit {
  private el = inject<ElementRef>(ElementRef);

  @Input() libAngularMyDatePickerCalendar: any;

  ngAfterViewInit(): void {
    const { inline, selectorHeight, selectorWidth, selectorPos } =
      this.libAngularMyDatePickerCalendar;
    const { style } = this.el.nativeElement;

    style.height = selectorHeight;
    style.width = selectorWidth;
    style.top = !inline ? selectorPos.top : '0';
    style.left = !inline ? selectorPos.left : '0';
  }
}
